const testData = [
  {
    clubName: 'Cornell 3 Day Startup',
    shortName: 'Cornell3DS',
    logo: 'Cornell3DS_logo.png',
    coverPhoto: 'Cornell3DS_cover.png',
    blurb: 'The mission of 3 Day Startup is to build entrepreneurial capabilities and cultures on university campuses. We do this by helping teams at universities around the globe organize 3DS events that help turn students into entrepreneurs, and connect those students with a powerful network of mentors, investors and talent.',
    openApps: false,
    appLink: null,
    website: 'https://cornell.3daystartup.org/',
    email: 'mailto:cornell.3daystartup@gmail.com',
    facebook: 'https://www.facebook.com/3-Day-Startup-at-Cornell-University-714836482035756/',
    tags: ['startup', 'entrepreneurship', 'software', 'ideas', 'technology', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Accounting Association',
    shortName: 'CAA',
    logo: 'CAA_logo.jpg',
    coverPhoto: 'CAA_cover.jpg',
    blurb: 'The Cornell Accounting Association (CAA) is a student-run organization dedicated to providing Cornell students with valuable resource and training for a career in accounting. The club’s success is measured by the number of CAA members that achieve jobs and internships as a result of combined student and CAA efforts. CAA regularly hosts a variety of accounting related events. We welcome any organization that wishes to work with us to accomplish all or a portion of these goals.',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellaccounting.org/',
    email: 'mailto:cornellaccounting@cornell.edu',
    facebook: 'https://www.facebook.com/cornellaccounting/',
    tags: ['accounting', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Actuarial Society',
    shortName: 'CAS',
    logo: 'CAS_logo.png',
    coverPhoto: 'CAS_cover.jpg',
    blurb: 'The Cornell Actuarial Society (CAS) is the only undergraduate professional organization that focuses on actuarial science at Cornell. We aim to empower talented and intelligent future actuaries through networking events, speaker series, and skill-building workshops. Our goal is to provide our members with skills to succeed professionally and personally.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellactuarialsociety.com/',
    email: 'mailto:cornellactuarialsociety@gmail.com',
    facebook: 'https://www.facebook.com/cornellactuarialsociety/',
    tags: ['finance', 'business', 'actuary', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Air and Sea Hospitality, Cornell',
    shortName: 'A&SHCornell',
    logo: 'A&SHCornell_logo.jpg',
    coverPhoto: 'A&SHCornell_cover.jpg',
    blurb: 'We are an organization that explores a very unique side of the hospitality industry not completely understood by many. A side that has seen so much progress in the last few decades and which continues to change each day. The aviation and cruise industry involves more than just purchasing a plane/cruise fare, boarding, and arriving at your destination. Every aspect of that simple process comes with variables that dictate everything ranging from the price you pay to the quality of service you receive onboard!',
    openApps: false,
    appLink: null,
    website: 'http://orgsync.rso.cornell.edu/org/hotelwingssocietycornell68189/home',
    email: 'mailto:airandseahosp@gmail.com',
    facebook: 'https://www.facebook.com/airandsea/',
    tags: ['hospitality', 'hotel', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Alpha Fund',
    shortName: 'AlphaCornell',
    logo: 'AlphaCornell_logo.jpg',
    coverPhoto: 'AlphaCornell_cover.jpg',
    blurb: 'The Alpha Fund of Cornell is one of the longest running student-led investment funds on campus. Since our founding in 2007, we have educated and engaged students in the world of finance and investing. We are a long/short tactical fund with a growth at a reason price (GARP) strategy. We manage over thirty thousand dollars of our members\' money and have posted consistent returns since our inception.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellalphafund.com/',
    email: 'mailto:alphacornell@gmail.com',
    facebook: 'https://www.facebook.com/CornellAlphaFund/',
    tags: ['finance', 'investing', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Academy of Environmental Engineers',
    shortName: 'AAEE',
    logo: 'AAEE_logo.jpg',
    coverPhoto: 'AAEE_cover.jpg',
    blurb: 'Our program Educational Objectives (PEOs) are to: Produce graduates who demonstrate in their professional practice strong technical abilities and advance in careers in Environmental Engineering and related disciplines. Produce graduates who will complete advanced degrees in engineering and related professional fields; Produce graduates who assume leadership positions, and contribute to understanding environmental problems and the design, construction, and operation of solutions of societal problems involving environmental systems.',
    openApps: false,
    appLink: null,
    website: 'https://enve.cornell.edu/american-academy-environmental-engineers/',
    email: 'mailto:aaee.cornell@gmail.com',
    facebook: 'https://www.facebook.com/Cornell-American-Academy-of-Environmental-Engineers-146119678786133/',
    tags: ['environmental', 'sustainability', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Indian Science and Engineering Society',
    shortName: 'AISES',
    logo: 'AISES_logo.jpg',
    coverPhoto: 'AISES_cover.jpg',
    blurb: 'American Indian Science & Engineering Society (AISES) is a student organization that meets to discuss various areas of interest within the STEM fields (science, technology, engineering, and mathematics). Our vision for Cornell’s AISES chapter is to be the new generation of educated Native leaders who will study and contribute to the building of communities among Native Americans. Our ultimate goal is to be a catalyst for the advancement of American Indian scholars in the field of science and technology.',
    openApps: false,
    appLink: null,
    website: 'https://aiisp.cornell.edu/student-life/native-american-student-organizations/aises/',
    email: 'mailto:',
    facebook: '',
    tags: ['STEM', 'engineering', 'ethnic', 'native', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell University American Institute of Aeronautics and Astronautics',
    shortName: 'CornellAIAA',
    logo: 'CornellAIAA_logo.png',
    coverPhoto: 'CornellAIAA_cover.jpg',
    blurb: 'Cornell AIAA is the Cornell student branch of the American Institute of Aeronautics and Astronautics, a professional society for anyone interested in aerospace engineering. We connect students to opportunities in research and industry and host lectures, internship/research panels, museum trips, and other events.',
    openApps: false,
    appLink: null,
    website: 'http://cornellaiaa.webflow.io/',
    email: 'mailto:ark83@cornell.edu',
    facebook: 'https://www.facebook.com/cornellaiaa/',
    tags: ['aeronautics', 'astronomy', 'aerospace', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Institute of Chemical Engineers',
    shortName: 'AIChE',
    logo: 'AIChE_logo.png',
    coverPhoto: 'AIChE_cover.png',
    blurb: 'The purpose of AIChE is to strengthen and enrich the Cornell ChemE community experience with professional, social and philanthropic programming.',
    openApps: false,
    appLink: null,
    website: 'https://cornellaiche.org/',
    email: '',
    facebook: 'https://www.facebook.com/cornellaiche/',
    tags: ['chemistry', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Mock World Health Organization',
    shortName: 'AMWHO',
    logo: 'AMWHO_logo.jpg',
    coverPhoto: 'AMWHO_cover.jpg',
    blurb: 'AMWHO stands as the national model-WHO organization for leading annual simulations in different universities. The organization strives to create chapters across the nation, where students can debate and form local conferences, and gather delegations from their school to attend AMWHO’s national conferences. The organization’s entire purpose is centered around interactive student learning on pertinent global health events like the World Health Assembly. Moreover, AMWHO seeks to have chapters in all universities for furthering the standard of global health policy education in the nation. Given our rotating national conference from different chapter to chapter, students involved in AMWHO can receive a chance to host this now distinguished event at their own university.',
    openApps: false,
    appLink: null,
    website: 'https://www.amwho.org/',
    email: 'mailto:',
    facebook: 'https://www.facebook.com/AMWHOrganization/',
    tags: ['health', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Society of Civil Engineers',
    shortName: 'ASCE',
    logo: 'ASCE_logo.jpg',
    coverPhoto: 'ASCE_cover.jpg',
    blurb: 'The American Society of Civil Engineers chapter at Cornell is a student group who invites members from among Civil Engineering majors to participate in community service events, engineering competitions and other activities. The group participates in the annual concrete canoe and steel bridge competitions, taking teams who work on each project to regional and national competitions around the country. ',
    openApps: false,
    appLink: null,
    website: null,
    email: 'mailto:asce@cornell.edu',
    facebook: null,
    tags: ['civilengineering', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'American Society of Mechanical Engineers',
    shortName: 'ASME',
    logo: 'ASME_logo.png',
    coverPhoto: 'ASME_cover.png',
    blurb: 'We are the Cornell University chapter of the American Society of Mechanical Engineers. We support the Mechanical Engineering Undergraduate class. We hold social events, out-reach events, setup student-faculty events, and host recruiting companies.',
    openApps: false,
    appLink: null,
    website: 'http://orgsync.rso.cornell.edu/org/cornellasme/home',
    email: 'mailto:ASME@cornell.edu',
    facebook: 'https://www.facebook.com/CornellASME',
    tags: ['mechanicalengineering', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Anjali',
    shortName: 'CornellAnjali',
    logo: 'CornellAnjali_logo.jpg',
    coverPhoto: 'CornellAnjali_cover.jpg',
    blurb: 'Founded in 2011, Anjali aims to spread the awareness of Bharatanatyam and other classical dance styles by performing and competing on and off campus.',
    openApps: false,
    appLink: null,
    website: 'https://cornellanjali.wixsite.com/cornellanjali',
    email: 'mailto:cornell.anjali@gmail.com',
    facebook: 'https://www.facebook.com/CornellAnjali/',
    tags: ['Indian', 'culture', 'dance', 'performance', 'competition'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Anthropology Exchange',
    shortName: 'CAE',
    logo: 'CAE_logo.jpg',
    coverPhoto: 'CAE_cover.jpg',
    blurb: 'The Cornell Anthropology Exchange serves as the forum for undergraduate anthropology and archaeology students.',
    openApps: false,
    appLink: null,
    website: null,
    email: null,
    facebook: 'https://www.facebook.com/CornellAnthropologyExchange',
    tags: ['anthropology', 'archaeology', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Ascend',
    shortName: 'Ascend',
    logo: 'Ascend_logo.jpg',
    coverPhoto: 'Ascend_cover.jpg',
    blurb: 'Ascend, established in 2005, is the largest, non-profit Pan-Asian organization for business professionals in North America. Ascend Cornell, operating under the guidance and sponsorship of New York Metro Regional Council, offer students opportunities for professional development and networking. Ascend Cornell strives to build connections between students and professional member and prepare students for their career objectives and future leadership roles.',
    openApps: false,
    appLink: null,
    website: 'http://ascendcornell.org/',
    email: null,
    facebook: 'https://www.facebook.com/ascendcornell/',
    tags: ['business', 'panasian', 'professional', 'ethnic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Association of Computer Science Undergraduates',
    shortName: 'ACSU',
    logo: 'ACSU_logo.png',
    coverPhoto: 'ACSU_cover.jpg',
    blurb: 'The Association of Computer Science Undergraduates (ACSU) hosts social gatherings (i.e. pre-enroll brunch), faculty events (where you get to meet professors), educational events (i.e. latex workshop), and company events (where you get to network with companies like Google and Microsoft). Everyone is invited to come to the events. There is a membership fee of $5, and it gives you access to the listserv, a free T-shirt, and the opportunity to get your resume sent out to the companies attending the networking events. ',
    openApps: false,
    appLink: null,
    website: 'https://acsu.cornell.edu/what.html',
    email: 'mailto:acsu@cornell.edu',
    facebook: 'https://www.facebook.com/CornellACSU/',
    tags: ['computerscience', 'professional', 'technology'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Association of Medicine and Philanthropy',
    shortName: 'CAMP',
    logo: 'CAMP_logo.png',
    coverPhoto: 'CAMP_cover.jpg',
    blurb: 'CAMP, or Cornell Association of Medicine and Philanthropy, is a STEM and Pre-health focused organization on campus. Our purpose is to broaden perspectives on areas of medical work other than a single pre-medical purpose as well as to raise awareness and give back through philanthropic events to underrepresented causes. We admit all students who demonstrate a genuine interest in the organization with our purpose and support and encourage all STEM students’ interests. CAMP has weekly meetings for members of Wednesdays from 5-6 in Malott 203 or Goldwin Smith Hall G64 on Cornell\'s campus. Explore our website to see how you can get involved!',
    openApps: false,
    appLink: null,
    website: 'http://cornell-medicine-philanthropy.herokuapp.com/',
    email: 'mailto:cornellmedicinephilanthropy@gmail.com',
    facebook: 'https://www.facebook.com/CornellAMP/',
    tags: ['medicine', 'philanthropy', 'prehealth', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'AIESEC Cornell',
    shortName: 'AIESEC',
    logo: 'AIESEC_logo.jpg',
    coverPhoto: 'AIESEC_cover.jpg',
    blurb: 'Active in 126 countries, and with over 86,000 members, AIESEC is the world\'s largest non-political, not-for-profit, student-run organization. AIESEC aims to achieve its vision of "peace and fulfillment of humankind\'s potential" through fostering leadership in globally-minded young people and promoting understanding and cooperation across cultures.',
    openApps: false,
    appLink: null,
    website: 'http://www.aiesec-cornell.org/',
    email: null,
    facebook: 'https://www.facebook.com/AIESEC.Cornell.Alumni/',
    tags: ['understanding', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'BigRed//Hacks',
    shortName: 'BRH',
    logo: 'BRH_logo.png',
    coverPhoto: 'BRH_cover.jpg',
    blurb: 'BigRed//Hacks is the first ever student-run, large-scale hackathon at Cornell University. Across three days, students from all across the northeast will gather to build the coolest and most innovative projects, meet amazing people, and win some prizes along the way!',
    openApps: false,
    appLink: null,
    website: 'https://www.bigredhacks.com/',
    email: 'mailto:info@bigredhacks.com',
    facebook: 'https://www.facebook.com/bigredhacks/',
    tags: ['hacking', 'computerscience', 'technology'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Black Ivy Pre-Law Society',
    shortName: 'BIPLS',
    logo: 'BIPLS_logo.jpg',
    coverPhoto: 'BIPLS_cover.jpg',
    blurb: 'The Black Ivy Pre-Law Society vows to support our society members in striving for excellence and is guided by our founding values: Ethics, Equality, Excellence, and Economy. In line with our third principle, Excellence, Black Ivy provides academic, interpersonal, mentorship, and experiential resources to ensure that our members are receiving well-rounded preparation for law school applications and an ultimate legal career. To support academic development, Black Ivy leverages our partnership with Testmasters and provides LSAT office hours for our members. To support professional and mentorship development, Black Ivy frequently interacts with the Cornell Law School and their BLSA chapter, in addition to hosting internal bonding events which foster a collective support system within the general body. To support experiential development, Black Ivy coordinates 1-2 law school tours a semester and organizes lectures with professors and legal professionals who can provide industry insight.  ',
    openApps: false,
    appLink: null,
    website: 'https://blackivyplsociety.wixsite.com/cornell',
    email: null,
    facebook: 'https://www.facebook.com/BlackIvyPLSociety/',
    tags: ['prelaw', 'black', 'ethnic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Business Analytics',
    shortName: 'CBA',
    logo: 'CBA_logo.png',
    coverPhoto: 'CBA_cover.png',
    blurb: 'Established in 2016, Cornell Business Analytics (CBA) is a student-run organization that offers pro-bono business analytics services to on-campus and off-campus clients. Our goal stems from the idea that data-driven decision making is vital for successful businesses and organizations. Through providing pro-bono business analytics services, CBA offers hands-on project experience and business analytics education to our members. CBA also aims to educate Cornell students about business analytics and foster a community of individuals interested in the field.',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellbusinessanalytics.com/',
    email: 'mailto:cornellbusinessanalytics@gmail.com',
    facebook: 'https://www.facebook.com/CornellBusinessAnalytics/',
    tags: ['business', 'consulting', 'datascience', 'finance'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Club Managers Association of America',
    shortName: 'CMAA',
    logo: null,
    coverPhoto: null,
    blurb: 'The Club Managers Association of America (CMAA) is the professional Association for managers of membership clubs. With close to 6,800 members across all classifications, our manager members run more than 2,500 country, golf, city, athletic, faculty, yacht, town and military clubs. The objectives of the Association are to promote and advance friendly relations among persons connected with the management of clubs and other associations of similar character; to encourage the education and advancement of its members; and to assist club officers and members, through their managers, to secure the utmost in efficient and successful operations.',
    openApps: false,
    appLink: null,
    website: 'https://www.cmaa.org/',
    email: null,
    facebook: 'https://www.facebook.com/CornellCMAA/',
    tags: ['clubmanagement', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Club of Taiwan',
    shortName: 'CCT',
    logo: 'CCT_logo.jpg',
    coverPhoto: 'CCT_cover.jpg',
    blurb: 'We cater to the Cornell Taiwanese community and its various interests, both professionally and outside the classroom. We build connections between students and alumni - a network in which students can grow and develop. We are a community - a society bound together in identity and companionship.',
    openApps: false,
    appLink: null,
    website: 'http://cornellcluboftaiwan.com/',
    email: null,
    facebook: 'https://www.facebook.com/CornellClubOfTaiwan/',
    tags: ['Taiwan', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Consulting Club',
    shortName: 'CCC',
    logo: 'CCC_logo.png',
    coverPhoto: 'CCC_cover.jpg',
    blurb: 'Cornell Consulting (also known as Cornell Consulting Club) is a student-run management consulting firm. For their clients, they offer a range of consulting services (i.e. strategy, technology). Their teams have tackled client engagements in the following industries: high-tech, oil & gas, financial services, venture capital, investment banking, non-profit, materials manufacturing, education, hospitality, legal, and public sector. Past engagements have included both large clients (Fortune 500s, a top university, and international companies) and small clients (local startups, national startups, and a regional museum). ',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellconsultingclub.org/',
    email: 'mailto:cornellconsultingclub@gmail.com',
    facebook: 'https://www.facebook.com/cornellconsulting/',
    tags: ['consulting', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Consulting Group',
    shortName: 'CCG',
    logo: 'CCG_logo.jpg',
    coverPhoto: 'CCG_cover.jpg',
    blurb: 'Cornell Consulting Group (CCG) is a student organization that provides strategic consulting services to businesses, education institutions and non-pro fit organizations. Founded in 2007, we have advised over 60 clients across a diverse range of industry and functional areas, and have become the premier undergraduate consulting organization at Cornell University. Our dedicated team of student consultants deliver high impact services to clients through semester-long projects in the Fall and Spring academic semesters. With support from experienced faculty advisers from the Johnson and Dyson schools at Cornell as well as unique research resources, we help organizations accomplish their goals by providing data-driven insights.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellconsultinggroup.org/',
    email: 'mailto:CCG.CORNELL@GMAIL.COM',
    facebook: 'https://www.facebook.com/Cornell-Consulting-Group-335756379868310/',
    tags: ['consulting', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Creative Computing Club',
    shortName: 'CreativeCC',
    logo: 'CreativeCC_logo.jpg',
    coverPhoto: 'CreativeCC_cover.jpg',
    blurb: 'The Creative Computing Club is a student organization at Cornell University focused on helping students explore the intersection of computing and the arts.',
    openApps: false,
    appLink: null,
    website: 'https://www.creativecomputing.club/',
    email: 'mailto:sa837@cornell.edu',
    facebook: 'https://www.facebook.com/creativecomputing.at.cornell/',
    tags: ['software', 'technology', 'projects', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell CS+Social Good',
    shortName: 'CornellCS4Good',
    logo: 'CornellCS4Good_logo.png',
    coverPhoto: 'CornellCS4Good_cover.jpg',
    blurb: 'At Cornell CS+Social Good, we aim to build, engage, and empower the society using technology. We’ll aim high, but stay realistic about what we can do.',
    openApps: false,
    appLink: null,
    website: null,
    email: null,
    facebook: 'https://www.facebook.com/cornellcs4good/',
    tags: ['computerscience', 'socialimpact', 'technology'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Dairy Science Club',
    shortName: 'CUDS',
    logo: null,
    coverPhoto: null,
    blurb: 'The purpose of CUDS is to provide opportunities for the educational enrichment of the dairy industry for current CUDS members, the Cornell community and beyond. Extension and outreach initiatives are met through social, educational and philanthropic events and service. Fund raising is required for current activities and educational trips and to support the sustainability of the club into the future.',
    openApps: false,
    appLink: null,
    website: 'https://ansci.cals.cornell.edu/undergraduate/clubs-organizations/dairy-science-club-cuds/',
    email: 'mailto:ckh53@cornell.edu',
    facebook: 'https://www.facebook.com/Cornelluniversitydairyscienceclub/',
    tags: ['dairy', 'science', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Debate in Science and Health',
    shortName: 'DSH',
    logo: 'DSH_logo.jpg',
    coverPhoto: 'DSH_cover.png',
    blurb: 'DSH is a casual environment where members can choose their level of commitment to suit their individual needs and schedules. Students interested in health, research, or policy are encouraged to join because the skills and values of debating are the most essential in those fields, yet often the least developed in students.',
    openApps: false,
    appLink: null,
    website: 'https://dshcornell.wixsite.com/dshcornell',
    email: 'mailto:mas245@cornell.edu',
    facebook: 'https://www.facebook.com/DSHCornell',
    tags: ['debate', 'health', 'research', 'policy', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'The Dilmun Hill Barn Project',
    shortName: 'DilmunHill',
    logo: 'DilmunHill_logo.jpg',
    coverPhoto: 'DilmunHill_cover.jpg',
    blurb: 'The Dilmun Hill Barn Project is led by an interdisciplinary team of students from the Colleges of Engineering, Architecture, Art and Planning, Human Ecology, and Agriculture and Life Sciences.\n'
      + 'Together, we plan to leverage the human resources and partnerships available at Cornell University to design and build a barn structure that will implement innovative and ecological design and technology to serve as a model for both small and medium-sized farming operations, in addition to other college farms seeking sustainably designed infrastructure.  Our new barn will include educational spaces for labs and workshops, vegetable processing facilities, and equipment storage.',
    openApps: false,
    appLink: null,
    website: 'https://blogs.cornell.edu/dilmunhillbarnproject/',
    email: 'mailto:amh345@cornell.edu',
    facebook: 'https://www.facebook.com/DilmunHillBarnProject/',
    tags: ['engineering', 'architecture', 'agriculture', 'sustainable', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Dyson Inclusion and Diversity',
    shortName: 'DysID',
    logo: 'DysID_logo.png',
    coverPhoto: 'DysID_cover.png',
    blurb: 'We wish to create a more proactive inclusion of students through the creation of Dys ID. Improving academic and social integration is a prime objective.The creation of this organization is based upon a conviction that every Cornellian regardless of race, color or creed can reap the full benefits of the Applied Economics and Management experience when given access to accurate knowledge and opportunities.',
    openApps: false,
    appLink: null,
    website: 'http://dysid.strikingly.com/',
    email: 'mailto:dysoninclusionanddiversity@gmail.com',
    facebook: 'https://www.facebook.com/DysonID/',
    tags: ['business', 'inclusion', 'diversity', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Economics Society',
    shortName: 'CES',
    logo: 'CES_logo.jpg',
    coverPhoto: 'CES_cover.jpg',
    blurb: 'The Cornell Economics Society (CES) is the largest and longest running undergraduate economics and pre-business society at Cornell. Hundreds of undergraduate members and alumni share a passion for the study of economics and its applications. As a society, we exist not only to serve the academic needs of our members but also to serve as a guide to attaining their professional goals and to provide a sense of community. We accomplish this through networking sessions, socials, career and class search assistance, and our annual Econ Week.',
    openApps: false,
    appLink: null,
    website: 'https://cornelleconsociety.com/',
    email: 'mailto:ces@cornell.edu',
    facebook: 'https://www.facebook.com/TheCornellEconomicsSociety/',
    tags: ['economics', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'eMed: Society of Engineers in Medicine',
    shortName: 'eMed',
    logo: 'eMed_logo.webp',
    coverPhoto: 'eMed_cover.webp',
    blurb: 'eMed’s goal is to promote the interests of students in engineering pursuing a career in medicine, by allowing its members to gain development in the areas of service, medical professionalism, and peer relations within the Cornell Engineering Premedical student body.',
    openApps: false,
    appLink: null,
    website: 'https://emedcornell.wixsite.com/emedcornell',
    email: 'mailto:emedcornell@gmail.com',
    facebook: null,
    tags: ['medicine', 'premed', 'engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Engineering Career Fair Team',
    shortName: 'ECAFT',
    logo: 'ECAFT_logo.jpg',
    coverPhoto: 'ECAFT_cover.jpg',
    blurb: 'Our goal is to empower and engage the Cornell community by connecting employers to students and improving students\' professional development skills through our workshops, career fair prep events, and outreach events.',
    openApps: false,
    appLink: null,
    website: 'http://cornellengineeringcareerfair.com/',
    email: 'mailto:ecaft@cornell.edu',
    facebook: 'https://www.facebook.com/ECaFT',
    tags: ['engineering', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Engineers for a Sustainable World',
    shortName: 'ESW',
    logo: 'ESW_logo.jpg',
    coverPhoto: 'ESW_cover.png',
    blurb: 'Engineers for a Sustainable World (ESW) is a national, non-profit network committed to building a better world. Established in 2002 at Cornell University, ESW is comprised of 4,000+ students, university faculty and professionals who are dedicated to building a more sustainable world for current and future generations.',
    openApps: false,
    appLink: null,
    website: 'https://esw.engineering.cornell.edu/',
    email: 'mailto:eswcornell@gmail.com',
    facebook: 'https://www.facebook.com/ESWCornell/',
    tags: ['sustainability', 'engineering', 'projectteam', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'The Epicurean Society',
    shortName: 'EpicureanSociety',
    logo: 'EpicureanSociety_logo.jpg',
    coverPhoto: 'EpicureanSociety_cover.jpg',
    blurb: 'The Epicurean Society\'s mission is to supplement the current gastronomical knowledge of our members in order to build their appreciation and knowledge of the culinary world. The Epicurean Society will unite students, alumni, and industry leaders with a strong interest in food and beverage in an effort to promote industry networking.',
    openApps: false,
    appLink: null,
    website: 'https://orgsync.com/56151/chapter?fbclid=IwAR0mKJT43Opc_V1pS2r7sdkZck1OQ3Iqj4yu1lb_CrqP36wOv2NDDuqMcuw',
    email: 'mailto:hs748@cornell.edu',
    facebook: 'https://www.facebook.com/EpicureanSociety',
    tags: ['gastronomy', 'culinary', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Fashion Collective',
    shortName: 'CFashionC',
    logo: 'CFashionC_logo.png',
    coverPhoto: 'CFashionC_cover.jpg',
    blurb: 'The Cornell Fashion Collective, formerly the Cornell Design League, is a student-run organization that provides members of the Cornell community with an outlet to express creativity in fashion and fashion management. Each spring, our organization presents a professional runway show featuring the talent of students who both design apparel and manage the operations of the show. Our organization gives students, both undergraduate and graduate, the opportunity to practice design, demonstrate their talents, and learn how to produce a large-scale fashion event.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellfashioncollective.com/',
    email: 'mailto:cornellfashioncollective@gmail.com',
    facebook: 'https://www.facebook.com/CornellFashionCollective',
    tags: ['fashion', 'design', 'creativity', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Fashion Industry Network',
    shortName: 'CFIN',
    logo: 'CFIN_logo.png',
    coverPhoto: 'CFIN_cover.jpg',
    blurb: 'Cornell Fashion Industry Network (CFIN) is a student run organization at Cornell University. Our group works to bring members of the fashion industry to Cornell to discuss their career paths and industry experiences. Students are able to connect with these speakers to gain insight about entering the fashion and apparel world.',
    openApps: false,
    appLink: null,
    website: 'http://www.fashionindustrynetwork.cornell.edu/',
    email: 'mailto:cornellfashionnetwork@gmail.com',
    facebook: 'https://www.facebook.com/cornellfashionindustrynetwork/',
    tags: ['fashion', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Female Leadership in Hospitality at Cornell University',
    shortName: 'FLIHCU',
    logo: 'FLIHCU_logo.png',
    coverPhoto: 'FLIHCU_cover.png',
    blurb: 'The purpose of the Female Leadership in Hospitality Club is to educate and encourage future female leaders in the hospitality industry.',
    openApps: false,
    appLink: null,
    website: 'https://flihcornell.weebly.com/',
    email: 'mailto:cornell.flih@gmail.com',
    facebook: 'https://www.facebook.com/shafemaleleadership/timeline',
    tags: ['hospitality', 'female', 'leadership', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Finance Club',
    shortName: 'CFC',
    logo: 'CFC_logo.png',
    coverPhoto: 'CFC_cover.png',
    blurb: 'Cornell Finance Club (CFC) provides its members the skills and connections to navigate the financial services industry. The organization is founded upon three pillars: new member education, stock pitches, and portfolio management. CFC prides itself on being open to students from all majors and aims to cultivate genuine curiosity in financial markets.',
    openApps: true,
    appLink: '#',
    website: 'https://cornellfinanceclub.org/',
    email: 'mailto:cornellfinanceclub@gmail.com',
    facebook: 'https://www.facebook.com/cornellfinanceclub/',
    tags: ['finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'john.jpg',
      },
      {
        name: 'Tim Apple',
        picture: 'apple.jpg',
      },
    ],
  },
  {
    clubName: 'Financial Risk Management Club of Cornell',
    shortName: 'FRMC',
    logo: null,
    coverPhoto: null,
    blurb: 'The Financial Risk Management Club of Cornell was founded in Spring 2015 to create a collaborative and educational space for students interested in financial risk management. Our main focus is educating our members about financial risk management and its related careers. Below are some of the current activities in which our members participate.',
    openApps: false,
    appLink: null,
    website: 'http://frmcc.org/index.php',
    email: null,
    facebook: null,
    tags: ['finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Food Science Club',
    shortName: 'CFSC',
    logo: 'CFSC_logo.jpg',
    coverPhoto: 'CFSC_cover.png',
    blurb: 'Stay up to date with all the happenings of Cornell Food Science Club as we together explore the scientific principles of the food that sustains us! ',
    openApps: false,
    appLink: null,
    website: null,
    email: null,
    facebook: 'https://www.facebook.com/cornellfoodscienceclub/',
    tags: ['food', 'science', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Forte',
    shortName: 'Forte',
    logo: 'Forte_logo.png',
    coverPhoto: 'Forte_cover.jpg',
    blurb: 'Whether you\'re an adventurer, listener, or creator, Forte Campus @ Cornell is the ultimate career connection for smart women at Cornell. At Forté, you will find a diverse community that will embrace your unique character and help you develop your talents both professionally and personally. Our members are undergraduate women striving to become the next movers and shakers within the business world. They are on-campus leaders and lifelong friends. Our organization is open to membership from every background and any major, and the support and mentorship our members receive is indispensable.',
    openApps: false,
    appLink: null,
    website: 'https://www.fortecampuscornell.com/',
    email: 'mailto:fortecampuscornell@gmail.com',
    facebook: 'https://www.facebook.com/ForteCampusCornell/',
    tags: ['business', 'female', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Global Economics and Finance Society',
    shortName: 'GEFS',
    logo: 'GEFS_logo.jpg',
    coverPhoto: 'GEFS_cover.png',
    blurb: 'GEFS is an outlook for students interested in global business and international affairs to develop the skills needed to understand changing global conditions,what drives institutional change and how consumer behavior will change over time.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellgefs.com/',
    email: 'mailto:cornellgefs@gmail.com',
    facebook: 'https://www.facebook.com/CornellGEFS',
    tags: ['economics', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Hacking Club',
    shortName: 'CornellHacking',
    logo: null,
    coverPhoto: null,
    blurb: 'We are a group dedicated to understanding, deconstructing, and ultimately breaking systems in order to advance computer and network security. Our main purpose is to compete in global hacking competitions known as CTFs. We also work on hacking related software projects.',
    openApps: false,
    appLink: null,
    website: 'https://chc.cs.cornell.edu/',
    email: null,
    facebook: 'https://www.facebook.com/groups/738252822943403/',
    tags: ['hacking', 'computerscience'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Hedge Fund',
    shortName: 'CHF',
    logo: 'CHF_logo.png',
    coverPhoto: 'CHF_cover.jpg',
    blurb: 'The Cornell Hedge Fund is Cornell\'s largest undergraduate investment organization. \n'
      + '\n'
      + 'Through real-world investing experience, ongoing education, and mentorship, we seek to provide students with the opportunities to develop their skills and interests in finance, regardless of their background. We are committed to our foundational values of integrity, innovation, and diversity to sustain an atmosphere that maximizes our members\' personal and professional growth.',
    openApps: false,
    appLink: null,
    website: 'https://cornellhedgefund.com/',
    email: 'mailto:recruitment.chf@gmail.com',
    facebook: 'https://www.facebook.com/TheCornellHedgeFund/',
    tags: ['finance', 'business', 'investing', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'History of Art Majors Society',
    shortName: 'HistArtMajors',
    logo: 'HistArtMajors_logo.jpg',
    coverPhoto: 'HistArtMajors_cover.jpg',
    blurb: 'The History of Art Majors’ Society (HAMS) has provided a way for Cornell history of art majors to enhance their knowledge about the discipline of art history beyond the classroom. Students work under the guidance of the Director of Undergraduate Studies in the Department of the History of Art and Visual Studies.',
    openApps: false,
    appLink: null,
    website: 'https://curatedhams.wordpress.com/?fbclid=IwAR02233-5fYfwzU91CNKsu80Gip-HpMiJrJL0RxNJF4v-K9i-LKpgMhKaOw',
    email: 'https://curatedhams.wordpress.com/contactus/',
    facebook: 'https://www.facebook.com/Cornell.HAMS/',
    tags: ['history', 'art', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Ho Nun De Kah',
    shortName: 'HoNunDeKah',
    logo: 'HoNunDeKah_logo.png',
    coverPhoto: null,
    blurb: 'As the official junior and senior honor society of the College of Agriculture and Life Sciences, Ho-Nun-De-Kah strives to foster relationships between our members, faculty members, and the general student body. Our purpose is to aid members in the pursuit of their goals and to assist faculty members and the student body in their endeavors to benefit our community. Ho-Nun-De-Kah offers free tutoring services to all CALS students in many course subjects. Our prestigious membership is comprised of the top ten percent of the junior class and the top twenty percent of the senior class as determined by grade point average.',
    openApps: false,
    appLink: null,
    website: 'https://cornellhndk.wordpress.com/',
    email: 'mailto:scw77@cornell.edu',
    facebook: null,
    tags: ['honorsociety', 'CALS', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Hospitality Consulting',
    shortName: 'CHC',
    logo: 'CHC_logo.jpg',
    coverPhoto: 'CHC_cover.jpg',
    blurb: 'Cornell Hospitality Consulting (CHC) was founded in 2005 by ambitious Cornell University students who wanted valuable experience applying the theories they learned in the classroom to the real world. Today, CHC is a group of over 20 dedicated student consultants who still embody a core principal of applying theory to practice and a core mission of prioritizing client objectives first and foremost. The key to our client service is our ability to combine the ambitious drive of our consultants with resources from one of the world’s best hospitality research schools. Furthermore, our consultants represent a broad range of experiences within the hospitality industry including Finance, Real Estate, Marketing, Food and Beverage Operations, and Restaurant and Hotel Development.',
    openApps: false,
    appLink: null,
    website: 'http://www.cornellchc.com/welcome/',
    email: 'mailto:chcrecruiting@gmail.com',
    facebook: 'https://www.facebook.com/Cornell-Hospitality-Consulting-113581408721342/',
    tags: ['hospitality', 'professional', 'business'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Hospitality Financial and Technology Professionals',
    shortName: 'HFTP',
    logo: null,
    coverPhoto: null,
    blurb: 'As part of Hospitality Financial and Technology Professionals (HFTP), The Cornell University Chapter is dedicated to enriching the hospitality industry in New York and the surrounding area. Visitors and non-members are always welcome.',
    openApps: false,
    appLink: null,
    website: 'https://www.hftp.org/chapters/my_chapter/main_template.cfm?showChapter=110',
    email: null,
    facebook: null,
    tags: ['hospitality', 'technology', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Hospitality Sales and Marketing Association International',
    shortName: 'HSMAI',
    logo: 'HSMAI_logo.png',
    coverPhoto: 'HSMAI_cover.png',
    blurb: 'HSMAI is a global organization of sales, marketing and revenue management professionals committed to growing business for hotels and their partners.',
    openApps: false,
    appLink: null,
    website: 'http://www.vantagehsmai.org/',
    email: null,
    facebook: 'https://www.facebook.com/CornellHSMAI',
    tags: ['hospitality', 'marketing', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Hospitality Students International',
    shortName: 'HSI',
    logo: 'HSI_logo.png',
    coverPhoto: 'HSI_cover.png',
    blurb: 'The Hospitality Students International Cornell Chapter was founded in 2002 by Cornell University School of Hotel Administration and the Cornell International Hoteliers Association (CIHA).  It was established to assist students with professional development in international hospitality, to provide them with opportunities to broaden their global business perspectives, and to share our knowledge and experiences in the global hospitality industry. ',
    openApps: false,
    appLink: null,
    website: 'http://hsi.weebly.com/index.html',
    email: 'mailto:hsi.cornell@gmail.com',
    facebook: 'https://www.facebook.com/cornellHSI/',
    tags: ['hospitality', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'HotelEzraCornell',
    shortName: 'HEC',
    logo: 'HEC_logo.jpg',
    coverPhoto: 'HEC_cover.jpg',
    blurb: 'Hotel Ezra Cornell is a three-day, student-run business conference for hospitality industry leaders and members of the Cornell community from across the globe. A 93-year tradition of the School of the Hotel Administration, HEC is one of the oldest organizations at Cornell and an unparalleled introduction to the students, faculty, and alumni of the preeminent hospitality program in the nation. Featuring some of the most talented individuals in the business, the conference will discuss the latest developments in hospitality and include leisure events for attendees to network with other professionals and meet the students who will be leading the industry in the future.',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellhec.com/',
    email: 'mailto:jyy29@cornell.edu',
    facebook: 'https://www.facebook.com/HotelEzraCornell/',
    tags: ['hospitality', 'business', 'professional', 'business'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Speech and Debate Society',
    shortName: 'CornellSDS',
    logo: 'CornellSDS_logo.jpg',
    coverPhoto: 'CornellSDS_cover.jpg',
    blurb: 'The Cornell Speech and Debate Society is the only university sponsored speech and debate organization at Cornell. We compete in Policy debate, Worlds debate, and Individual Speech events. The organization is one of tfhe largest of its kind in the United States, boasting over 120 members from diverse backgrounds.',
    openApps: false,
    appLink: null,
    website: 'https://forensics.cornell.edu/',
    email: null,
    facebook: 'https://www.facebook.com/cornellspeechdebate/',
    tags: ['forensics', 'debate', 'speech', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Hotel Society',
    shortName: 'CHS',
    logo: 'CHS_logo.jpg',
    coverPhoto: 'CHS_cover.jpg',
    blurb: 'CHS is committed to creating the world’s most engaging network for industry-defining alumni.  We are THE OFFICIAL ALUMNI ORGANIZATION of the Cornell University School of Hotel Administration and the premier hospitality network created by alumni for alumni.',
    openApps: false,
    appLink: null,
    website: 'https://www.chscollegiatechapter.com/',
    email: 'mailto:jl2592@cornell.edu',
    facebook: 'https://www.facebook.com/CHSCC/',
    tags: ['hospitality', 'academic', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Impact Investing',
    shortName: 'CII',
    logo: 'CII_logo.png',
    coverPhoto: 'CII_cover.png',
    blurb: 'Cornell Impact Investing (CII) is Cornell University\'s first undergraduate, impact-focused consulting organization. Our mission is to conduct financial and market due diligence for private equity firms whose missions involve the generation of positive social and environmental impact. We provide undergraduate students with opportunities to learn and implement financial tools and market research to do "more good" instead of "less bad".',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellimpactinvesting.org/',
    email: null,
    facebook: 'https://www.facebook.com/CornellImpact/',
    tags: ['investing', 'consulting', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Information Science Student Association',
    shortName: 'ISSA',
    logo: 'ISSA_logo.png',
    coverPhoto: 'ISSA_cover.png',
    blurb: 'Information Science is one of the fastest growing and cutting edge majors offered at Cornell University. The Information Science Student Association (ISSA) is here to improve the student experience and spread the word about the major. The ISSA plans networking events, social events, corporate information sessions and tech talks with faculty.',
    openApps: false,
    appLink: null,
    website: 'http://issa.infosci.cornell.edu/',
    email: 'mailto:ISSA-L-request@cornell.edu',
    facebook: null,
    tags: ['informationscience', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Institute of Electrical and Electronics Engineers',
    shortName: 'IEEE',
    logo: 'IEEE_logo.jpg',
    coverPhoto: 'IEEE_cover.jpg',
    blurb: 'Cornell IEEE is a student led branch of the national Institute of Electrical and Electronics Engineers (IEEE) within the Cornell\'s ECE department. Our mission is to build a strong, collaborative community of STEM students (undergraduate and graduate) and faculty at Cornell University by hosting social, networking, professional development, educational workshops and outreach events. We also regularly host corporate outreach events to provide companies access to Cornell ECE and CS students.',
    openApps: false,
    appLink: null,
    website: 'http://ieeecornell.org/',
    email: 'mailto:ieee@ece.cornell.edu',
    facebook: 'https://www.facebook.com/ieeecornell/',
    tags: ['electricalengineering', 'engineering', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell International Affairs Society',
    shortName: 'CIAS',
    logo: 'CIAS_logo.jpg',
    coverPhoto: 'CIAS_cover.jpg',
    blurb: 'The Cornell International Affairs Society (CIAS) is a student-run umbrella organization dedicated to enhancing student\'s understanding of international affairs while developing their skills in public speaking, leadership, and diplomacy at Cornell University. Under CIAS, you will find three Model UN conferences, a regular publication on international affairs, Cornell\'s official Model UN traveling team, and some really cool people.',
    openApps: false,
    appLink: null,
    website: 'https://www.thecias.org/',
    email: 'https://www.thecias.org/contact',
    facebook: 'https://www.facebook.com/The.CIAS/',
    tags: ['internationalaffairs', 'academic', 'speech'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell International Business Association',
    shortName: 'CIBA',
    logo: 'CIBA_logo.png',
    coverPhoto: 'CIBA_cover.png',
    blurb: 'The Cornell International Business Association (CIBA) was founded due to the lack of international focus among the business and professional clubs on campus, under the mission statement of educating students on international business. The mission statement of CIBA was expanded from just scholarship to a focus on professional development and a stronger on-campus presence. We take on semester long consulting projects serving local, domestic, and international clients while still continuing education and professional development internally.',
    openApps: false,
    appLink: null,
    website: 'https://www.cornelliba.com/',
    email: 'mailto:cornelliba@gmail.com',
    facebook: 'https://www.facebook.com/cornell.iba',
    tags: ['business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Investment Banking Club',
    shortName: 'CIBC',
    logo: 'CIBC_logo.jpg',
    coverPhoto: 'CIBC_cover.png',
    blurb: 'The Cornell Investment Banking Club (CIBC) provides Cornell undergraduate students with the unique opportunity to jump-start a career in investment banking by connecting members with banks and financial firms, giving real experience with investment banking work, and teaching core finance concepts.',
    openApps: false,
    appLink: null,
    website: 'https://cornell-ib.com/',
    email: 'mailto:cornellinvestmentbanking@gmail.com',
    facebook: 'https://www.facebook.com/cornellinvestmentbankingclub/',
    tags: ['investing', 'banking', 'finance', 'professional', 'business'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Life Changing Labs',
    shortName: 'LCL',
    logo: 'LCL_logo.jpg',
    coverPhoto: 'LCL_cover.jpg',
    blurb: 'Life Changing Labs is a non-profit organization that supports Cornell’s top entrepreneurially minded students. The LCL student management team runs or supports the following key initiatives each year: \n' +
      '\n'
      + '- Cornell\'s summer incubator for founders plus individual students looking to gain hands on experience with startups\n'
      + '- Cornell Entrepreneurship Kickoff event\n'
      + '- Big Idea Competition\n'
      + '- eHub Office Hours\n'
      + '- Life Changing Makeathon\n'
      + '- LCL Pitch & Dinners',
    openApps: false,
    appLink: null,
    website: 'http://www.lifechanginglabs.com/',
    email: 'mailto:contact@lifechanginglabs.com',
    facebook: 'https://www.facebook.com/lifechanginglabs/',
    tags: ['entrepreneurship', 'software', 'academic', 'business'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Marketing Organization',
    shortName: 'CMO',
    logo: 'CMO_logo.jpg',
    coverPhoto: 'CMO_cover.jpg',
    blurb: 'Our organization will help students with their professional careers by demonstrating the relevance of marketing in every aspect of the business world.',
    openApps: false,
    appLink: null,
    website: 'https://www.cornellmarketing.com/',
    email: 'mailto:marketingatcornell@gmail.com',
    facebook: 'https://www.facebook.com/CornellMarketingOrganization/',
    tags: ['marketing', 'business', 'professional', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Materials Society',
    shortName: 'CMS',
    logo: 'CMS_logo.jpg',
    coverPhoto: 'CMS_cover.jpg',
    blurb: 'The Cornell Materials Society (CMS) is the organization that represents the interests of undergraduate students in the Materials Science and Engineering Department to faculty and College of Engineering as a whole.  We work to foster relationships between department faculty and students and to expose students to cutting-edge materials research. Each semester, we fund an all expenses paid trip to a materials research conference that is open to members of CMS.  We are also active in recruiting incoming freshmen and sophomores to the MSE major and have active relationships with student groups across all engineering disciplines. ',
    openApps: false,
    appLink: null,
    website: null,
    email: null,
    facebook: 'https://www.facebook.com/cornellmaterialssociety/',
    tags: ['materials', 'science', 'engineering', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Minority ILR Student Organization',
    shortName: 'MILRSO',
    logo: 'MILRSO_logo.png',
    coverPhoto: 'MILRSO_cover.jpg',
    blurb: 'The mission of the Minority ILR Student Organization is to foster a strong professional network and community for minority students interested in many career fields.',
    openApps: false,
    appLink: null,
    website: null,
    email: null,
    facebook: 'https://www.facebook.com/MILRSO/',
    tags: ['ILR', 'minority', 'diversity', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Mortar Board Der Hexenkreis Senior Honor Society',
    shortName: 'MortarBoard',
    logo: 'MortarBoard_logo.jpg',
    coverPhoto: 'MortarBoard_cover.jpg',
    blurb: 'Mortar Board, a national honor society, recognizes college seniors for outstanding achievement in scholarship, leadership, and public service. The organization includes 228 chapters as well as 50 alumni chapters, and since its founding in 1918 has initiated nearly a quarter of a million college seniors. Among Mortar Board’s many distinguishing achievements is the fact that it was the first honor society for women. Although Mortar Board became a co-ed honor society in the 1970s, these unique roots still resound in the current traditions and values that we seek to uphold.',
    openApps: false,
    appLink: null,
    website: 'http://www.mbdh.org/',
    email: null,
    facebook: 'https://www.facebook.com/cornellmb/',
    tags: ['honorsociety', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Mutual Investment Club of Cornell',
    shortName: 'MICC',
    logo: 'MICC_logo.png',
    coverPhoto: 'MICC_cover.png',
    blurb: 'Mutual Investment Club of Cornell (MICC) is Cornell\'s oldest and largest--by assets--investment club on campus. Fully owning all of its own capital, the club invests across an array of industries while utilizing a variety of strategies. The organization leverages its history in order to provide members the best educational platform and business network possible. ',
    openApps: false,
    appLink: null,
    website: 'cornell-micc.com',
    email: null,
    facebook: 'https://www.facebook.com/CornellMicc/',
    tags: ['investing', 'finance', 'business', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell National Society of Black Engineers',
    shortName: 'CornellNSBE',
    logo: 'CornellNSBE_logo.jpg',
    coverPhoto: 'CornellNSBE_cover.jpg',
    blurb: 'The National Society of Black Engineers (NSBE) is a 501(c)(3) nonprofit organization dedicated to the academic and professional success of African-American engineering and technical students and professionals.  NSBE offers its members leadership training, professional and academic development, mentoring opportunities, community service outreach programs, and scholarships.',
    openApps: false,
    appLink: null,
    website: 'https://cornellnsbe.weebly.com/',
    email: 'president.nsbecu@gmail.com',
    facebook: 'https://www.facebook.com/groups/27566573755/',
    tags: ['academic', 'black', 'engineering', 'minority'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'National Society of Minorities in Hospitality',
    shortName: 'NSMH',
    logo: 'NSMH_logo.png',
    coverPhoto: 'NSMH_cover.jpg',
    blurb: 'Mission: Educate in order to aid in the recruitment, retention, support, and advancement of minority students in the hospitality industry. Build and maintain relationships between hospitality professionals and minority students in ways that encourage lifelong commitment to the organization.',
    openApps: false,
    appLink: null,
    website: 'https://orgsync.com/56156/chapter',
    email: 'mailto:cornell@nsmh.org',
    facebook: null,
    tags: ['minority', 'hospitality', 'professional'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'National Organization of Minority Architects Students ',
    shortName: 'NOMAS',
    logo: null,
    coverPhoto: 'NOMAS_cover.jpg',
    blurb: 'National Organization of Minority Architects Students (NOMAS) is the student group under the leadership of the National Organization of Minority Architects (NOMA), and is designed to expose architecture students of color to the history, culture, and practice of professional architects of color. An annual NOMA conference is held which gives students an opportunity to attend workshops, learn more about the impact of current issues in architecture on people of color, and meet and network with professional architects of color. Students raise funds to attend the conference and participate in the student design competition.',
    openApps: false,
    appLink: null,
    website: 'https://aap.cornell.edu/resources/student-organization/nomas',
    email: 'mailto:akiely@cornell.edu',
    facebook: null,
    tags: ['architecture', 'minority', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Nightlife Hospitality Club',
    shortName: 'NHC',
    logo: 'NHC_logo.png',
    coverPhoto: 'NHC_cover.jpg',
    blurb: 'The Nightlife Hospitality Club’s mission is to cultivate an understanding of the nightlife industry which includes premium nightclubs, casinos, and bars.',
    openApps: false,
    appLink: null,
    website: 'https://orgsync.com/91300/chapter?fbclid=IwAR23sDYMjsEOTLT4CJW4YZk0W_EEsUIxLjjeW0aUK6uuZwxrjt5u-7H0C4w',
    email: 'mailto:mq52@cornell.edu',
    facebook: 'https://www.facebook.com/NightlifeHospitalityClub/',
    tags: ['hospitality', 'business', 'academic'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Open Source Cornell',
    shortName: 'OpenSourceCornell',
    logo: 'OpenSourceCornell_logo.png',
    coverPhoto: 'OpenSourceCornell_cover.jpg',
    blurb: 'We began as an organization in the Spring of 2011 at Cornell with a simple idea: if there\'s no club for open source enthusiasts on campus, why not make one ourselves? We\'ve since become the primary source of education about Free and Open Source Software and taken the responsibility of hosting Linux Install Fests on campus every semester alongside Cornell\'s Students for Free Culture, the Ithaca Free Software Association, and Ubuntu New York State.',
    openApps: false,
    appLink: null,
    website: 'https://www.opensourcecornell.org',
    email: 'mailto:opensource@cornell.edu',
    facebook: 'https://www.facebook.com/opensourcecornell/',
    tags: ['software', 'computerscience', 'hacking'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Design & Tech Initiative',
    shortName: 'CornellDTI',
    logo: 'dtiteam_logo.png',
    coverPhoto: 'dtiteam_cover.jpg',
    blurb: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dui faucibus in ornare quam viverra. Id interdum velit laoreet id. Aliquam malesuada bibendum arcu vitae elementum curabitur vitae nunc. Lobortis feugiat vivamus at augue eget. Cras fermentum odio eu feugiat pretium nibh ipsum consequat. Laoreet non curabitur gravida arcu ac tortor dignissim convallis aenean. Et tortor consequat id porta nibh venenatis cras sed. Vestibulum rhoncus est pellentesque elit ullamcorper dignissim. Neque laoreet suspendisse interdum consectetur. Lacinia at quis risus sed. Rhoncus dolor purus non enim. Diam phasellus vestibulum lorem sed risus. Mauris nunc congue nisi vitae suscipit tellus. Aenean sed adipiscing diam donec adipiscing tristique risus nec.\n',
    openApps: true,
    appLink: '#',
    website: 'https://www.cornelldti.org',
    email: 'mailto:hello@cornelldti.org',
    facebook: 'https://www.facebook.com/cornelldti/',
    tags: ['webdev', 'appdev', 'design', 'productmanagement', 'engineering'],
    officers: [
      {
        name: 'John Smith',
        picture: 'dummyOfficer.png',
      },
      {
        name: 'Tim Apple',
        picture: 'dummyOfficer.png',
      },
    ],
  },
  {
    clubName: 'Cornell Data Science',
    shortName: 'CDS',
    logo: 'logo.jpg',
    coverPhoto: 'cover.jpg',
    blurb: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero.',
    openApps: true,
    appLink: '#',
    website: 'google.com',
    email: 'no@gmail.com',
    facebook: 'facebook.com',
    tags: ['a', 'b', 'c'],
    officers: [
      {
        name: 'John Smith',
        picture: 'john.jpg',
      },
      {
        name: 'Tim Apple',
        picture: 'apple.jpg',
      },
    ],
  },
  {
    clubName: 'Society of Women Engineers',
    shortName: 'SWE',
    logo: 'logo.jpg',
    coverPhoto: 'cover.jpg',
    blurb: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero.',
    openApps: true,
    appLink: '#',
    website: 'google.com',
    email: 'no@gmail.com',
    facebook: 'facebook.com',
    tags: ['a', 'b', 'c'],
    officers: [
      {
        name: 'John Smith',
        picture: 'john.jpg',
      },
      {
        name: 'Tim Apple',
        picture: 'apple.jpg',
      },
    ],
  },
  {
    clubName: 'Women In Computing Cornell',
    shortName: 'WICC',
    logo: 'logo.jpg',
    coverPhoto: 'cover.jpg',
    blurb: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero.',
    openApps: true,
    appLink: '#',
    website: 'google.com',
    email: 'no@gmail.com',
    facebook: 'facebook.com',
    tags: ['a', 'b', 'c'],
    officers: [
      {
        name: 'John Smith',
        picture: 'john.jpg',
      },
      {
        name: 'Tim Apple',
        picture: 'apple.jpg',
      },
    ],
  },
];

export default testData;
